import { gql } from '@apollo/client';
import client from '../services/graphql';

export const PROJECT_WITH_SURVEY_PAGES = gql`
  query project($id: ID!) {
    project(id: $id) {
    id
    testType
    welcomeContent
    thankYouContent
    welcomeTitle
    thankYouTitle
    sortRandom
    thankYouRedirectLink
    hasMrId
    surveys {
      id
      surveyType
      surveysPages {
        id
        pageName
        order
        skipLogic {
          conditions {
            id
            surveyPageId
            skipConditions {
              id
              questionId
              questionOptionId
              operation
            }
          }
        }
        displayQuestion {
          conditions {
            id
            questionsList
            displayConditions {
              id
              questionId
              questionOptionId
              operation
            }
          }
        }
        questions {
          id
          label
          questionType
          groupId
          questionOrder
          leftLabel
          rightLabel
          imageUrl
          imageKey
          displayTime
          matrixType
          multipleSelectionArray
          questionOptions {
            id
            label
            disqualify
            qualify
            optionType
            order
            imageUrl
            imageKey
            matrixOption
          }
        }
      }
    }
  }
}
`;

export const saveTestSessionAnswers = async (attributes) => {
  const query = gql`
    mutation SaveTestSessionAnswer($attributes: [TestSessionAnswerAttributes!]!) {
        saveTestSessionAnswer(attributes: $attributes) {
          testSessionAnswers {
            id
            question {
              id
              label
              questionType
              leftLabel
              rightLabel
              questionOrder
            }
          }
        }
      }
  `;

  const data = await client.getClient().mutate({
    mutation: query,
    variables: attributes,
  });

  if (data.error) {
    throw new Error('GraphQL request resulted in errors.');
  }

  return data?.data;
};

export const GET_QUESTION_OPTIONS = gql`
  query GetQuestionOptions($questionId: ID!) {
    questionOptions(questionId: $questionId) {
      id
      label
      order
    }
  }
`;
